export default { 
    apiKey: "AIzaSyB-NtKezuNOqH_sARAKudp0IpcTP5LvFxc",
    authDomain: "my-portfolio-efda3.firebaseapp.com",
    databaseURL: "https://my-portfolio-efda3.firebaseio.com",
    projectId: "my-portfolio-efda3",
    storageBucket: "my-portfolio-efda3.appspot.com",
    messagingSenderId: "1087985470958",
    appId: "1:1087985470958:web:1a39d6cb381b5095"
  }